/**
 * Created by Angelika on 05.09.2017.
 */
import * as actionTypes from '../constants/actionTypes';
import * as def from '../constants/defines';
import MobileDetect from 'mobile-detect';

const isMobile = (function() {
    let md = new MobileDetect(window.navigator.userAgent);
    return md.mobile() ? true : false;
})();

const initialState = {
    play: false,
    stopped: false,
    paused: isMobile ? true : false,
    muted: false,
    volume: def.VIDEO_INITIAL_VOLUME,
    quality: null,
    expanded: false,
    hlsLevels: [],
    hlsCurrentLevel: null,
    classes: null,
    isMobile: isMobile,
    hasError: false,
    error_title: null,
    error_description: null
};
initialState.classes = _classes(initialState);

export function video(state = initialState, action) {
    let nextState = null;

    switch (action.type) {
        case actionTypes.PLAY_VIDEO:
            nextState = {
                ...state,
                paused: false,
                stopped: false,
                play: true
            };
            return {...nextState, classes: _classes(nextState) };

        case actionTypes.PAUSE_VIDEO:
            nextState = {
                ...state,
                paused: true,
                play: false,
                stopped: false
            };
            return {...nextState, classes: _classes(nextState) };
        
        case actionTypes.MUTE_VIDEO:
            nextState = {
                ...state,
                muted: !state.muted
            };
            return {...nextState, classes: _classes(nextState) };

        case actionTypes.CHANGE_VOLUME_VIDEO:
            nextState = {
                ...state,
                volume: +action.volume,
                muted: (action.volume > 0 ? false : true)
            };
            return {...nextState, classes: _classes(nextState) };

        case actionTypes.CHANGE_QUALITY_VIDEO:
            nextState = {
                ...state,
                quality: action.quality
            };
            return {...nextState, classes: _classes(nextState) };

        case actionTypes.EXPAND_VIDEO:
            nextState = {
                ...state,
                expanded: true
            };
            return {...nextState, classes: _classes(nextState) };

        case actionTypes.COLLAPSE_VIDEO:
            nextState = {
                ...state,
                expanded: false
            };
            return {...nextState, classes: _classes(nextState) };

        case actionTypes.SET_HLS_LEVELS:
            return {
                ...state,
                hlsLevels: action.levels
            };

        case actionTypes.SET_HLS_LEVEL_CURRENT:
            return {
                ...state,
                hlsCurrentLevel: action.current
            };

        case actionTypes.RESET_STATE_VIDEO:
            return {
                ...initialState,
                classes: _classes(initialState)
            };

        case actionTypes.SET_ERROR_VIDEO:
            return {
                ...state,
                hasError: action.error_description ? true : false,
                error_title: action.error_title,
                error_description: action.error_description
            };

        default:
            return state;
    }
}

function _classes(state) {
    let classes = [];
    for (let prop in state) {
        if (typeof state[prop] === 'boolean' && state[prop]) {
            classes.push(prop);
        }
    }
    return classes.join(' ');
}



// WEBPACK FOOTER //
// ./src/reducers/video.js